/**
 * Audio helpers for the Upload Calls flow.
 *
 * The in-browser WAV→MP3 converter (lamejs) that used to live here was
 * removed — non-MP3 uploads are transcoded server-side (ffmpeg) instead.
 */

/**
 * Check if a file is a WAV file.
 */
export function isWavFile(file: File): boolean {
  return /\.wav$/i.test(file.name) || file.type === 'audio/wav' || file.type === 'audio/x-wav';
}

/**
 * Get duration of an audio file (MP3, etc.) using the Audio element.
 */
export function getAudioDuration(file: File): Promise<number> {
  return new Promise((resolve) => {
    const audio = new Audio();
    audio.addEventListener('loadedmetadata', () => {
      resolve(Math.round(audio.duration));
      URL.revokeObjectURL(audio.src);
    });
    audio.addEventListener('error', () => {
      resolve(0);
      URL.revokeObjectURL(audio.src);
    });
    audio.src = URL.createObjectURL(file);
  });
}
